/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendSignedMRIContext} from '../api'

export const useMutationSendSignedMRIContext = createReactQueryMutationHook('sendSignedMRIContext', sendSignedMRIContext)
